@let valueIfList = valueIfListSg();
@let valueIfObject = valueIfObjectSg();
@let value = valueSg();

@if (valueIfList) {
  <atn-list-content [value]="valueIfList" />
} @else if (valueIfObject) {
  <atn-object-content [value]="valueIfObject" />
} @else if (value) {
  <!-- TODO: structure can be either list or object, so this is probably not
  needed unless we add new structure type -->
  <atn-standard-content [value]="value" />
}
